import actions from './actions'

// list helper
import ListHelper from '../../utils/listHelper'

const defaultMedia = {
    hashtag: [],
    type: 0,
    url: '',
    name: '',
    media_id: 0,
}

const initState = {
    medias: [],
    currentMedia: {},
    textSearch: '',
    lastTextSearch: '',

    total: 0,
    pageSize: 24,
    pageIndex: 1,

    // cache
    file: null,
    _status: 0,

    // modal
    modalMediaInfoState: false,
    modalConfirmDeleteMedia: false,
    currentListMedia: [],

    // selected media
    selectedMedia: [],
}

// compare function
const compareSameMedia = (a, b) => {
    return a.media_id === b.media_id
}

const _handleUpdateListMedias = (state, medias) => {
    let newMedias = []
    let selectedMedia = state.selectedMedia

    for (let index = 0; index < medias.length; index++) {
        let media = {
            ...medias[index],
            ...{
                isSelect: ListHelper.checkItemInList(
                    selectedMedia,
                    medias[index],
                    compareSameMedia
                ),
            },
        }
        newMedias.push(media)
    }

    return {
        ...state,
        ...{
            medias: newMedias,
            file: null,
        },
    }
}

const _handleUpdateSelectMediaState = (state, mid, selectState) => {
    let newMedias = []
    const medias = state.medias
    let selectedMedia = state.selectedMedia

    for (let index = 0; index < medias.length; index++) {
        let isSelect = medias[index].isSelect
        let media = medias[index]
        if (medias[index].media_id === mid) {
            isSelect = selectState

            media = {
                ...medias[index],
                ...{
                    isSelect,
                },
            }

            // update select list
            if (selectState === true) {
                if (
                    !ListHelper.checkItemInList(
                        selectedMedia,
                        media,
                        compareSameMedia
                    )
                )
                    selectedMedia = ListHelper.insertItemToList(
                        selectedMedia,
                        media
                    )
            } else {
                if (
                    ListHelper.checkItemInList(
                        selectedMedia,
                        media,
                        compareSameMedia
                    )
                )
                    selectedMedia = ListHelper.deleteItemInList(
                        selectedMedia,
                        a => compareSameMedia(a, media)
                    )
            }
        }

        newMedias.push(media)
    }

    return {
        ...state,
        ...{
            medias: newMedias,
            selectedMedia,
        },
    }
}

const _handleUpdateSelectedMedias = (state, selectedMedia) => {
    let newMedias = []
    let medias = state.medias

    for (let index = 0; index < medias.length; index++) {
        let media = {
            ...medias[index],
            ...{
                isSelect: ListHelper.checkItemInList(
                    selectedMedia,
                    medias[index],
                    compareSameMedia
                ),
            },
        }
        newMedias.push(media)
    }

    return {
        ...state,
        ...{
            medias: newMedias,
            selectedMedia,
            file: null,
        },
    }
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.LOAD_LIST_MEDIA:
            return state

        case actions.type.LOAD_LIST_MEDIA_SUCCESS:
            return _handleUpdateListMedias(state, action.payload.medias)

        case actions.type.SET_DEFAULT_CURRENT_MEDIA:
            return {
                ...state,
                ...{
                    file: null,
                    currentMedia: defaultMedia,
                },
            }

        case actions.type.UPDATE_CURRENT_MEDIA:
            return {
                ...state,
                ...{
                    currentMedia: {
                        ...state.currentMedia,
                        ...action.payload.media,
                    },
                },
            }

        case actions.type.SAVE_CURRENT_MEDIA:
            return state

        case actions.type.DELETE_MEDIA:
            return state

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        case actions.type.UPDATE_FILE:
            return {
                ...state,
                ...{
                    file: action.payload.file,
                },
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex,
                },
            }

        case actions.type.SHOW_MODAL_CURRENT_MEDIA_INFO:
            return {
                ...state,
                ...{
                    modalMediaInfoState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CURRENT_MEDIA_INFO:
            return {
                ...state,
                ...{
                    modalMediaInfoState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_DELETE_MEDIA:
            return {
                ...state,
                ...{
                    modalConfirmDeleteMedia: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_DELETE_MEDIA:
            return {
                ...state,
                ...{
                    modalConfirmDeleteMedia: false,
                },
            }

        case actions.type.UPDATE_SELECT_STATE_MEDIA:
            return _handleUpdateSelectMediaState(
                state,
                action.payload.mid,
                action.payload.selectState
            )

        case actions.type.UPDATE_SELECTED_MEDIAS:
            return _handleUpdateSelectedMedias(state, action.payload.medias)

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch,
                },
            }

        case actions.type.SEARCH_MEDIA:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch,
                },
            }

        default:
            return state
    }
}

export default reducer
